import { MultiFilterSelectItem } from '@modules/shared/components/multi-filter-select/multi-filter-select.component';

export enum EventAttendeeTicketOrderParticipantStatus {
  ACTIVE = 'ACTIVE',
  USED = 'USED',
  NOT_CLAIMED = 'NOT_CLAIMED',
  UNASSIGNED = 'UNASSIGNED',
}
export namespace EventAttendeeTicketOrderParticipantStatus {
  export function getAll() {
    return [
      EventAttendeeTicketOrderParticipantStatus.ACTIVE,
      EventAttendeeTicketOrderParticipantStatus.USED,
      EventAttendeeTicketOrderParticipantStatus.NOT_CLAIMED,
      EventAttendeeTicketOrderParticipantStatus.UNASSIGNED,
    ];
  }

  export function getForSellTicketsOnly() {
    return [
      EventAttendeeTicketOrderParticipantStatus.ACTIVE,
      EventAttendeeTicketOrderParticipantStatus.USED,
    ];
  }

  export function getStatusColor(
    status?: EventAttendeeTicketOrderParticipantStatus,
  ): string {
    switch (status) {
      case EventAttendeeTicketOrderParticipantStatus.UNASSIGNED:
        return '#FFA723';
      case EventAttendeeTicketOrderParticipantStatus.NOT_CLAIMED:
        return '#f6e633';
      case EventAttendeeTicketOrderParticipantStatus.USED:
        return '#B0B0B0';
      default:
        return '#33B977';
    }
  }

  export function getDisplayName(
    status?: EventAttendeeTicketOrderParticipantStatus,
  ): string {
    switch (status) {
      case EventAttendeeTicketOrderParticipantStatus.UNASSIGNED:
        return 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.UNASSIGNED';
      case EventAttendeeTicketOrderParticipantStatus.NOT_CLAIMED:
        return 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.NOT_CLAIMED';
      case EventAttendeeTicketOrderParticipantStatus.USED:
        return 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.USED';
      default:
        return 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.ACTIVE';
    }
  }

  export function getForFilter(): MultiFilterSelectItem[] {
    return [
      {
        value: EventAttendeeTicketOrderParticipantStatus.ACTIVE,
        label: 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.ACTIVE',
      },
      {
        value: EventAttendeeTicketOrderParticipantStatus.UNASSIGNED,
        label: 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.UNASSIGNED',
      },
      {
        value: EventAttendeeTicketOrderParticipantStatus.NOT_CLAIMED,
        label: 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.NOT_CLAIMED',
      },
      {
        value: EventAttendeeTicketOrderParticipantStatus.USED,
        label: 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.USED',
      },
    ];
  }

  export function getForAttendeeTicketsFilter(): MultiFilterSelectItem[] {
    return [
      {
        value: EventAttendeeTicketOrderParticipantStatus.ACTIVE,
        label: 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.ACTIVE',
      },
      {
        value: EventAttendeeTicketOrderParticipantStatus.USED,
        label: 'APP.BOOKING_SLOTS.PARTICIPANTS.STATUSES.USED',
      },
    ];
  }
}
